import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import { DeliveryMan, DeliveryManPayload } from 'app/types/users/deliveryMan'

export const createDeliveryMan = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.deliveryMen.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = DeliveryManPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<DeliveryMan>(
            {
                id: 999,
                ...payloadParsed.data,
                client: allManagers.filter((manager) =>
                    payloadParsed.data.client.includes(manager.id),
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
